module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-ss"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基本信息",
      "name": "first"
    }
  }, [_c('info')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "风险物质",
      "name": "second"
    }
  }, [(_vm.hasSubstanceType) ? _c('div', {
    staticClass: "grouped-table-container"
  }, _vm._l((_vm.groupedData), function(group, index) {
    return _c('el-card', {
      key: index,
      staticClass: "group-card"
    }, [(group.type) ? _c('template', {
      slot: "header"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatSubstanceType(group.type)))]), _vm._v(" "), _c('span', {
      staticClass: "q-value"
    }, [_vm._v("Q值合计: " + _vm._s(group.total.toFixed(2)))])])]) : _vm._e(), _vm._v(" "), _c('el-table', {
      ref: 'groupTable' + index,
      refInFor: true,
      staticClass: "sync-scroll",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": group.items,
        "border": "",
        "show-header": index === 0
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "cas",
        "label": "CAS号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "物质名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "criticalValue",
        "label": "临界量(吨)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "state",
        "label": "形态"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n                " + _vm._s(_vm.formatState(scope.row.state)) + "\n              ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "count",
        "label": "最大存储量(吨)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "purity",
        "label": "折纯量(吨)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "remark",
        "label": "补充说明"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "qValue",
        "label": "Q值"
      }
    })], 1)], 2)
  })) : _c('div', {
    staticClass: "normal-table-container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.materialdetail,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "物质名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cas",
      "label": "CAS号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "形态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.formatState(scope.row.state)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "数量(吨)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "criticalValue",
      "label": "临界量(吨)"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "应急物资",
      "name": "third"
    }
  }, [_c('detailone')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "应急队伍",
      "name": "fifth"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.teamData,
      "border": "",
      "height": "585"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "单位名称",
      "prop": "orgName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人",
      "prop": "linkman"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "处置能力",
      "prop": "description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "敏感保护目标区域",
      "name": "sixth"
    }
  }, [_c('sensprotection')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "案例",
      "name": "seventh"
    }
  }, [_c('casev')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "平面图",
      "name": "eighth"
    }
  }, [_c('planimg')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6daa752","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/burst/Digitization.vue
// module id = 1279
// module chunks = 2